module.exports = __webpack_public_path__ + "static/media/App icon Playboy.d47a21b0.png";